module.exports = __webpack_public_path__ + "img/wechat-public.5d13ad48.jpg";